;(function () {

"use strict";

var app = window.app;
var AppBridge = window['app-bridge'];

if (AppBridge) {

var actions = AppBridge.actions;
var History = actions.History;
var TitleBar = actions.TitleBar;
var Button = actions.Button;
var Redirect = actions.Redirect;
var Loading = actions.Loading;
var Toast = actions.Toast;
var Modal = actions.Modal;

}

function init() {

if (AppBridge) {

  function generateButton(params) {
    var button = Button.create(app, {
      label: params.label,
      message: params.message
    });

    button.subscribe(Button.Action.CLICK, function () {
      if (params.loading) {
        var loading = Loading.create(app);
        loading.dispatch(Loading.Action.START);
      }
      if (params.callback) {
        params.callback();
      }
      if (params.href) {
        var redirect = Redirect.create(app);
        redirect.dispatch(Redirect.Action.REMOTE, {
          url: params.href,
          newContext: true,
        });
      }
    });


    return button;
  }

  window.ShopifyApp = {};
  window.ShopifyApp.Bar = {
    initialize: function (params) {
      var buttons = params.buttons || {};

      if (params.buttons.secondary) {
        buttons.secondary = [generateButton(params.buttons.secondary)];
      } else {
        buttons.secondary = [];
      }

      console.log(params.buttons);

      if (params.buttons.primary) {
        buttons.primary = generateButton(params.buttons.primary);
      } else {
        buttons.primary = [];
      }

      TitleBar.create(app, {
        title: params.title,
        buttons: buttons
      });
    },

    loadingOn: function () {
      var loading = Loading.create(app);
      loading.dispatch(Loading.Action.START);
    },

    loadingOff: function() {
      var loading = Loading.create(app);
      loading.dispatch(Loading.Action.STOP);
    }
  }

  ShopifyApp.Bar.initialize({
    title: window.data.title,
    buttons: window.Buttons || {}
  });

  ShopifyApp.Modal = {
    alert: function (params, callback) {
      var okButton = Button.create(app, { label: 'OK' });
      okButton.subscribe(Button.Action.CLICK, () => {
        if (callback) {
          callback(true);
        }
        modal.dispatch(Modal.Action.CLOSE);
      });

      var modalOptions = {
        title: params.title,
        message: params.message,
        footer: {
          buttons: {
            primary: okButton
          },
        },
      };
      var modal = Modal.create(app, modalOptions);

      modal.dispatch(Modal.Action.OPEN);
      modal.subscribe(Modal.Action.CLOSE, () => {
        if (callback) {
          callback(true);
        }
      });
    },
    confirm: function (params, callback) {
      var okButtonOpts = { label: params.okButton };
      if (params.style === 'danger') {
        okButtonOpts.style = Button.Style.Danger;
      }
      var okButton = Button.create(app, okButtonOpts);
      okButton.subscribe(Button.Action.CLICK, () => {
        unsubscribe();
        if (callback) {
          callback(true);
        }
        modal.dispatch(Modal.Action.CLOSE);
      });
      var cancelButton = Button.create(app, { label: params.cancelButton });
      cancelButton.subscribe(Button.Action.CLICK, () => {
        unsubscribe();
        if (callback) {
          callback(false);
        }
        modal.dispatch(Modal.Action.CLOSE);
      });

      var modalOptions = {
        title: params.title,
        message: params.message,
        footer: {
          buttons: {
            primary: okButton,
            secondary: [cancelButton],
          },
        },
      };

      var modal = Modal.create(app, modalOptions);
      modal.dispatch(Modal.Action.OPEN);

      var unsubscribe = modal.subscribe(Modal.Action.CLOSE, () => {
        if (params.style === 'danger') {
          callback();
        } else {
          callback(true);
        }
      });
    }
  };

  ShopifyApp.flashNotice = function (string) {
    var toastOptions = {
      message: string,
      duration: 5000,
    };
    var toastNotice = Toast.create(app, toastOptions);
    toastNotice.dispatch(Toast.Action.SHOW);
  }

  ShopifyApp.redirect = function (url) {
    var redirect = Redirect.create(app);
    if (url.indexOf('/') !== 0) {
      url = '/'+url;
    }
    redirect.dispatch(Redirect.Action.ADMIN_PATH, {
      path: url,
    });
  }

  ShopifyApp.remoteRedirect = function (url) {
    var redirect = Redirect.create(app);
    if (url.indexOf('/') !== 0) {
      url = '/'+url;
    }
    redirect.dispatch(Redirect.Action.REMOTE, {
      path: url,
    });
  }

  ShopifyApp.internalRedirect = function (url) {
    var redirect = Redirect.create(app);
    redirect.dispatch(Redirect.Action.APP, url);

    if (url === window.location.pathname) {
      window.location.reload();
    }
  }

  ShopifyApp.Bar.loadingOff();

  if (window.hasToken) {
    console.log('adding history');
    var history = History.create(app);
    var action;

    if (window.hasLoaded) {
      action = History.Action.PUSH;
    } else {
      action = History.Action.REPLACE;
      window.hasLoaded = true;
    }
    history.dispatch(action, `${window.location.pathname}${window.location.search}`);
  }
}

}

module.exports = init;

}());